
import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor
} from '@angular/common/http';

import { catchError, from, map, mergeMap, Observable, of } from 'rxjs';
import { IdentityAuthService } from '../_services/identity-auth.service';

@Injectable()
export class TokenInterceptor {

    /**
     * Creates an instance of TokenInterceptor.
     * @param {IdentityAuthService} auth
     * @memberof TokenInterceptor
     */
    constructor(public auth: IdentityAuthService) { }

    /**
     * Intercept all HTTP request to add JWT token to Headers
     * @param {HttpRequest<any>} request
     * @param {HttpHandler} next
     * @returns {Observable<HttpEvent<any>>}
     * @memberof TokenInterceptor
     */
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (!request.url.includes('identity/refresh')) {
            let tokenObservable = from(this.auth.getAccessToken())
                .pipe(
                    map(token => {
                        if (token) {
                            request = request.clone({
                                setHeaders: {
                                    Authorization: `Bearer ${token}`
                                }
                            });
                        }
                        return request;
                    }),
                    catchError((err) => {
                        return of(request);
                    }))
                .pipe(mergeMap(req => next.handle(req)));

            return tokenObservable;
        } else {
            return next.handle(request);
        }
    }
}